import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { HashRouter } from "react-router-dom";
import './styles/globals.css'; // <- important

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
     <HashRouter>
     <App />
     </HashRouter>
  </React.StrictMode>
)
